/* eslint-disable */
/* eslint-disable max-lines-per-function */
import React, { useEffect, useState, useContext } from 'react';
import DesktopEmployeeProfile from './desktopViewEmpProfile';
import MobileEmployeeProfile from './mobileViewEmpProfile';
import CircularProgress from '@mui/material/CircularProgress';
import LocationOnIcon from '../../Assets/images/svg/dar_emp_location.svg';
import EmailIcon from '../../Assets/images/svg/dar_emp_email.svg';
import PhoneIcon from '../../Assets/images/svg/dar_emp_phone.svg';
import EventIcon from '../../Assets/images/svg/dar_emp_experience.svg';
import EmployeeIdIcon from '../../Assets/images/svg/dar_emp_employee_id.svg';
import LocationOnIconMobile from '../../Assets/images/svg/dar_emp_location_mobile.svg';
import EmailIconMobile from '../../Assets/images/svg/dar_emp_email_mobile.svg';
import PhoneIconMobile from '../../Assets/images/svg/dar_emp_phone_mobile.svg';
import EventIconMobile from '../../Assets/images/svg/dar_emp_experience_mobile.svg';
import { getEmployeeData } from './fetchUserInfo';
import './employeeProfile.scss';
import { useLocation } from 'react-router-dom';
import ProjectsPage from './Projects/projects';
import SkillsCertAward from './EmployeeAchievementDetails/employeeAchievementDetails';
import SkillsCertAwardMobile from './EmployeeAchievementDetails/employeeAchievementDetailsMobile';
import Onboarding from './Onboarding';
import TrainingDetails from './Training/trainingDetails';
import Performance from './Performance/performance';
import { AuthContext } from '../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../Constants/modules';

const ResponsiveEmployeeProfile = () => {
  const [isMobileView, setIsMobileView] = useState(false);
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [employeeId, setEmployeeId] = useState(null);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('');
  const { emailId } = location.state || {};
  const { userProfile } = useContext(AuthContext);

  const userEmail = userProfile?.email;
  const [reportees, setReportees] = useState([]);


  const permissionOnboarding = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.EMPLOYEE_ONBOARDING] || []
    : [];

  const permissionAchievements = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.EMPLOYEE_ACHIEVEMENTS] || []
    : [];

  const permissionTrainings = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.EMPLOYEE_TRAINING] || []
    : [];

  const permissionProjects = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.EMPLOYEE_PROJECTS] || []
    : [];

  const permissionPerformance = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.EMPLOYEE_PERFORMANCE] || []
    : [];

  useEffect(() => {
    fetchEmployeeDetails(emailId);
  }, [emailId]);

  useEffect(() => {
    if (userEmail) {
      fetchEmployeeIdAndReportees(userEmail);
    }
  }, [userEmail]);

  const buttonLabels = [
    {
      access:
        permissionOnboarding.includes('read')
        || permissionOnboarding.includes('create')
        || permissionOnboarding.includes('update')
        || reportees.includes(emailId),
      label: 'Onboarding',
    },
    {
      access:
        permissionAchievements.includes('read')
        || permissionAchievements.includes('create')
        || permissionAchievements.includes('update')
        || reportees.includes(emailId),
      label: 'Skills, awards and certifications',
    },
    {
      access:
        permissionTrainings.includes('read')
        || permissionTrainings.includes('create')
        || permissionTrainings.includes('update')
        || reportees.includes(emailId),
      label: 'Trainings and assessments',
    },
    {
      access:
        permissionProjects.includes('read')
        || permissionProjects.includes('create')
        || permissionProjects.includes('update')
        || reportees.includes(emailId),
      label: 'Projects',
    },
    {
      access:
        permissionPerformance.includes('read')
        || permissionPerformance.includes('create')
        || permissionPerformance.includes('update')
        || emailId === userEmail
        || reportees.includes(emailId),
      label: 'Performance',
    },
  ]
    .filter(({ access }) => access) // Filter out those without access
    .map(({ label }) => label); // Map to get the labels

  useEffect(() => {
    const accessibleTabs = buttonLabels;
    setActiveTab(accessibleTabs.length > 0 ? accessibleTabs[0] : '');
  }, [emailId]);

  useEffect(() => {
    const checkMobileView = () => {
      setIsMobileView(window.innerWidth <= 768);
      setIsMobileScreen(window.innerWidth <= 576);
    };

    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  const fetchEmployeeDetails = async (email) => {
    setLoading(true);
    try {
      const payload = {
        filterValues: { emailId: email },
        fieldsToShow: [
          'employeeId',
          'fullName',
          'emailId',
          'vertical',
          'employeestatus',
          'photoDownloadUrl',
          'location',
          'designation',
          'mobileCountryCode',
          'mobile',
          'workExperience',
          'department',
          'dateofjoining',
          'reportingTo',
          'totalExperience',
          'photoSignedUrl',
        ],
      };
      const employeeData = await getEmployeeData(payload);
      setEmployee(employeeData[0] || []);
      setEmployeeId(employeeData[0]?.employeeId);
    } catch (error) {
      setEmployee([{ workExperience: [] }]);
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployeeIdAndReportees = async (email) => {
    try {
      const payloadForEmployeeId = {
        filterValues: { emailId: email },
        fieldsToShow: ['employeeId'],
      };
      const employeeIdResponse = await getEmployeeData(payloadForEmployeeId);
      const employeeIdValue = employeeIdResponse[0]?.employeeId || null;
      if (employeeIdValue) {
        const payloadForReportees = {
          filterValues: { reportingTo: employeeIdValue, employeeStatus: 'Active' },
          fieldsToShow: ['emailId', 'employeeId'],
        };
        const reporteesResponse = await getEmployeeData(payloadForReportees);
        setReportees(reporteesResponse.map(reportee => reportee.emailId));
      }
    } catch (error) {
      console.error('Error fetching employee ID and reportees:', error);
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  const employeeNameMenu = [
    {
      icon: EmployeeIdIcon,
      iconMobile: EmployeeIdIcon,
      label: 'employeeId',
      text: employeeId,
      displayOrder: 0,
    },
    {
      icon: LocationOnIcon,
      iconMobile: LocationOnIconMobile,
      label: 'location',
      text: employee.location,
      displayOrder: 1,
    },
    {
      icon: EmailIcon,
      iconMobile: EmailIconMobile,
      label: 'email',
      text: employee.emailId,
      displayOrder: 2,
    },
    {
      icon: PhoneIcon,
      iconMobile: PhoneIconMobile,
      label: 'phone',
      text: employee.mobile,
      displayOrder: 3,
    },
    {
      icon: EventIcon,
      iconMobile: EventIconMobile,
      label: 'experience',
      text: employee.totalExperience ?? '3y 5m',
      displayOrder: 4,
    },
  ];

  const handleButtonClick = (label) => {
    setActiveTab(label);
  };

  const renderActiveTab = () => {
    switch (activeTab) {
    case 'Onboarding':
      return (
        <Onboarding
          employee={employee}
          organizationDetails={employee.workExperience}
          totalExperience={employee.totalExperience}
        />
      );
    case 'Skills, awards and certifications':
      return isMobileScreen ? (
        <SkillsCertAwardMobile userId={employeeId} />
      ) : (
        <SkillsCertAward userId={employeeId} />
      );
    case 'Trainings and assessments':
      return <TrainingDetails 
        userId={employeeId}
        userEmailId={employee.emailId}
        userName={employee.fullName}
    />;
    case 'Projects':
      return <ProjectsPage
        userId={employeeId}
        userEmailId={employee.emailId}
        userName={employee.fullName}
      />;
    case 'Performance':
      return (
        <Performance
          emailId={employee.emailId}
          employeeId={employee.employeeId}
          designation={employee.designation}
          department={employee.department}
          vertical={employee.vertical}
        />
      );
    default:
      return null;
    }
  };

  const projectDetails = [
    { label: 'Business Vertical', text: employee.vertical },
    { label: 'Department', text: employee.department },
    { label: 'Designation', text: employee.designation },
    { label: 'Date of joining', text: employee.dateofjoining },
    { label: 'Reporting manager', text: employee.reportingTo },
  ];

  return (
    <div className="employee-profile-master-outer-layer">
      <div className="employee-profile-master">
        {isMobileView ? (
          <MobileEmployeeProfile
            employee={employee}
            employeeNameMenu={employeeNameMenu}
            projectDetails={projectDetails}
          />
        ) : (
          <DesktopEmployeeProfile
            employee={employee}
            employeeNameMenu={employeeNameMenu}
            projectDetails={projectDetails}
          />
        )}
        <div className="profile-button-container">
          {buttonLabels.map((label) => (
            <button
              key={label}
              className={activeTab === label ? 'active-label' : ''}
              onClick={() => handleButtonClick(label)}
            >
              {label}
            </button>
          ))}
        </div>
        {renderActiveTab()}
      </div>
    </div>
  );
};

export default ResponsiveEmployeeProfile;
